module.exports = __webpack_public_path__ + "static/media/Birthday Party Boy.74cc9ed3.jpg";